import React from 'react'
import { SignalCellular0BarRounded, SignalCellular2BarRounded, SignalCellular3BarRounded, SignalCellular4BarRounded } from '@mui/icons-material'
import { isNil, isUndefined, lowerCase } from 'lodash'
import i18n from 'simple-react-i18n'
import { formatMilliers } from 'utils/StringUtil'
import { Grid, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { hasValue } from 'utils/NumberUtil'
import useApplicationSetting, { intParser } from 'utils/customHook/useApplicationSetting'
import SmallIndicator from './SmallIndicator'
import { VP_LEVELS, VP_LEVELS_PARAMETERS } from 'territory/constants/A3PConstants'
import { getVPLevelLabel } from 'territory/utils/A3PUtils'

const VPIndicator = ({ indicator, volume, withVolume, bigDisplay }) => {
    const m3unit = 'm3'
    const VPLevelLabel = useApplicationSetting(VP_LEVELS_PARAMETERS[indicator]?.label, v => hasValue(v) ? String(v) : null) ?? getVPLevelLabel(indicator)
    const globalVPLevelValue = useApplicationSetting(VP_LEVELS_PARAMETERS[indicator]?.value, v => hasValue(v) ? intParser(v) : null)
    const VPLevelValue = isUndefined(volume) ? globalVPLevelValue : volume
    const getIcon = () => {
        switch (indicator) {
            case VP_LEVELS.RESTRICTED: return <SignalCellular0BarRounded />
            case VP_LEVELS.HIGH: return <SignalCellular3BarRounded />
            case VP_LEVELS.VERY_HIGH: return <SignalCellular4BarRounded />
            case VP_LEVELS.NORMAL: default: return <SignalCellular2BarRounded />
        }
    }
    if (bigDisplay) {
        return (
            <Stack spacing={0.5}>
                <Grid container alignItems={'center'} spacing={1}>
                    {getIcon()}
                    {VPLevelLabel}
                </Grid>
                <Typography>{`${isNil(VPLevelValue) ? `${i18n.volume} ${lowerCase(i18n.notDefined)}` : `${formatMilliers(VPLevelValue)} ${m3unit}`}`}</Typography>
            </Stack>
        )
    }
    return (
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
            <SmallIndicator
                color='third'
                bgcolor='primary.veryLight'
                borderColor='primary.veryLight'
            >
                {getIcon()}
                {VPLevelLabel}
            </SmallIndicator>
            {withVolume && ` (${isNil(VPLevelValue) ? `${i18n.volume} ${lowerCase(i18n.notDefined)}` : `${formatMilliers(VPLevelValue)} ${m3unit}`})`}
        </Stack>
    )
}

VPIndicator.propTypes = {
    indicator: PropTypes.number,
    volume: PropTypes.number,
    withVolume: PropTypes.bool,
    bigDisplay: PropTypes.bool,
}

export default VPIndicator